import * as yup from "yup";
import { passwordRegex } from '../../common/regex';
export const validationSchema = yup.object().shape({

  newPassword: yup .string()
  .required("Password is required")
  .matches(
    passwordRegex,
    "Password must be 8–12 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character."
  ),
  confirmPassword: yup.string()
    .oneOf([yup.ref('confirmPassword'), undefined], "Passwords must match")
    .required("Confirm Password is required"),
});